<template>
    <div v-loading="listLoading">
        <div class="lke-bg" v-if="info.name">
            <div>
                <div class="lke-num">编号: {{paperId}}</div>
                <div class="lke-bg-in">
                    <div class="lke-top" v-if="info.frequency < info.examNum">
                        <span>{{info.name}}</span>
                        <el-tag type='success' effect="dark" v-if="info.examContinue === true" style="margin-left: 40px">考试中</el-tag>
                        <el-tag type='info' effect="dark" v-else style="margin-left: 40px">可考试</el-tag>
                    </div>
                    <div class="lke-top" v-else>
                        <span>{{info.name}}</span>
                    </div>
                    <div class="lke-mid">
                        <span style="margin-right:15px">可考上限:{{info.examNum}}次</span>    
                        <span>已考次数:{{info.frequency}}次</span>
                    </div>
                    <!-- <div class="lke-mid">
                        <span style="margin-right:15px">单选题:20题；</span>    
                        <span style="margin-right:15px">多选题:10题；</span>    
                        <span>判断题:30题</span> 
                    </div> -->
                    <div class="lke-mid">
                        <span style="margin-right:15px">考生姓名</span>    
                        <span>{{userInfo.name}}</span>
                    </div>
                    <div class="lke-mid">
                        <span style="margin-right:15px">准考证号</span>    
                        <span v-if="roles === 'notEnrolled'">{{userInfo.uid}}</span>
                        <span v-else>{{userInfo.sid}}</span>
                    </div>
                    <div class="lke-mid">
                        <span style="margin-right:15px">总分</span>    
                        <span>{{info.score}}分</span>
                    </div>
                    <div class="lke-mid">
                        <span style="margin-right:15px">作答时间</span>    
                        <span>{{info.time}}分钟</span>
                    </div>
                    <div class="lke-mid" v-if="info.exambatchBegin && info.exambatchEnd">
                        <span style="margin-right:15px">考试时间</span>    
                        <span>{{info.exambatchBegin | addtime}}  -  {{info.exambatchEnd | addtime}}</span>
                    </div>
                    <div class="lke-fot">
                        <span>注：请认真核对您的信息，如信息有误请联系管理员！</span>
                    </div>
                    <el-button type="primary" :loading="false" @click="openExamination" v-if="canStartExam">{{info.examContinue === false ? '开始作答' : '继续作答'}}</el-button>
                    <el-button type="danger" :loading="false" v-else>{{info.startDisabledReason || '考试已关闭，无需再次点击'}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getpaperinfo, getpaper } from "@/api/index"
import moment from 'moment';
export default {
    name: 'examination',
    data() {
        return {
            listLoading: false,
            paperId: undefined,
            courseId: undefined,
            courseDetailId: undefined,
            exambatchId: undefined,
            info: {},
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        roles() {
            return this.$store.state.roles
        },
        canStartExam() {
            if (this.info && Object.prototype.hasOwnProperty.call(this.info, 'canStart')) {
                return this.info.canStart === true
            }
            return this.info.frequency < this.info.examNum && this.info.isSuccess === false
        },
    },
    created() {
        this.paperId = this.GetQueryValue('paperId');
        this.courseId = this.GetQueryValue('courseId');
        this.courseDetailId = this.GetQueryValue('courseDetailId');
        this.exambatchId = this.GetQueryValue('exambatchId');
        this.getpaperinfo();
    },
    mounted() {

        // this.settime();

    },
    filters: {
        addtime(val) {
            return moment(val).format("GGGG年MM月DD日");
        },
    },
    watch: {

    },
    methods: {

        settime() {
            setTimeout(() => {
                this.getpaperinfoAgain();
                this.settime()
            }, 10000);
        },

        getpaperinfoAgain() {
            let obj = {
                paperId: this.paperId
            }
            if (this.exambatchId) {
                obj.exambatchId = this.exambatchId
            }
            getpaperinfo(obj).then(response => {
                this.info = response
            })
        },

        getpaperinfo() {
            this.listLoading = true;
            let obj = {
                paperId: this.paperId
            }
            if (this.courseId) {
                obj.courseId = this.courseId
            }
            if (this.courseDetailId) {
                obj.courseDetailId = this.courseDetailId
            }
            if (this.exambatchId) {
                obj.exambatchId = this.exambatchId
            }
            if (this.paperId) {
                obj.paperId = this.paperId
            }
            getpaperinfo(obj).then(response => {
                
                this.listLoading = false
                this.info = response
            })
        },

        GetQueryValue(queryName) {
            let query = window.location.href.split("?")[1];
            if (!query) {
                return null;
            }
            let vars = query.split("&");
            for (let i = 0; i < vars.length; i++) {
                 let pair = vars[i].split("=");
                 if (pair[0] == queryName) { return pair[1]; }
             }
             return null;
         },

        openExamination() {
            this.$confirm('一旦开始考试中途将不可取消', '考试提示', {
                confirmButtonText: '开始考试',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.openExaminationIndex();
            }).catch(() => {
            });
        },

        openExaminationIndex() {
            this.listLoading = true
            let obj = {};
            let text = ''
            if (this.courseId) {
                obj.courseId = this.courseId
                text = text + '&courseId=' + this.courseId
            }
            if (this.courseDetailId) {
                obj.courseDetailId = this.courseDetailId
                text = text + '&courseDetailId=' + this.courseDetailId
            }
            if (this.exambatchId) {
                obj.exambatchId = this.exambatchId
                text = text + '&exambatchId=' + this.exambatchId
            }
            if (this.paperId) {
                obj.paperId = this.paperId
                text = text + '&paperId=' + this.paperId
            }
            
            
            // return
            getpaper(this.paperId,obj).then(response =>{
                
                text = text + '&paperInfoId=' + response._id
                window.open("/#/examinationIndex?paperId=" + this.paperId + text);
                this.$message({
                message: '若没有跳转考试，请检查浏览器是否阻止打开新弹窗',
                type: 'warning'
                });
                this.getpaperinfo();
            })
            // this.$router.push({ name: 'examinationIndex',
            //                     query: obj});
        },

    },
};
</script>

<style>

</style>

<style scoped>
.lke-bg{
    display: flex;
    align-items: center;
    justify-content: center;
}
.lke-bg > div{
    width: 964px;
    padding: 40px 20px;
}
.lke-num{
    font-size: 14px;
    margin-bottom: 25px;
}
.lke-bg-in{
    text-align: center;
}
.lke-top{
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
}
.lke-mid{
    font-size: 18px;
    letter-spacing: 1px;
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.lke-fot{
    font-size: 16px;
    letter-spacing: 1px;
    padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/examination/examination.vue